<section>
  <ul class="nav steps mb-4 {{headerClass}}" id="pills-tab" role="tablist">
    <li class="nav-item" *ngFor="let step of results; let index = index">
      <button [disabled]="!tabsEnabled" class="nav-link" type="button" [ngClass]="{ active: selectedIndex == index }"
        (click)="navigateToIndex(index)">
        {{ index + 1 }}. {{ step.label }}
      </button>
    </li>
  </ul>
  <!-- <header>
        <h2>Step {{selectedIndex + 1}}/{{steps.length}}</h2>
    </header> -->

  <div [style.display]="selected ? 'block' : 'none'" [class]="bodyClass">
    <!-- Content from the CdkStep is projected here -->
    <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
  </div>
</section>
